import { trackElementInteraction } from '../util/analytics'

interface CustomPlaylistCheckboxData {
  event_name: string
  event_data: Record<string, unknown>
}

up.compiler(
  '[data-custom-playlist-checkbox]',
  (
    element: HTMLInputElement,
    { event_name: eventName, event_data: eventData }: CustomPlaylistCheckboxData,
  ) => {
    const form = element.closest('form')!

    up.watch(element, () => {
      element.disabled = true
      up.submit(form)
      // tracking: video_page.learning_plan_select_private_add, video_page.learning_plan_select_private_remove
      // tracking: video_page.learning_plan_select_assigned_add, video_page.learning_plan_select_assigned_remove
      // element.id comes from the `up-id` of the section the checkbox sits in, learning_plan_id from its
      // `data-tracking-context`; element.text would be the plan's name, which the admin typed.
      trackElementInteraction(element, eventName, { ...eventData, text: '' })
    })
  },
)
